module.exports = __webpack_public_path__ + "media/images/logos/logo-fundation-2d48667fe31452298e2f2cbe9a251efd.svg";